import api from '../../../../helpers/api';

export const getArtisanPrivateInquiry = body =>
  api.post('private-artisan-inquiry/get-single-artisan-private-inquiry/', {
    ...body
  });

export const getArtisanPrivateInquiries = body =>
  api.post(
    body.url
      ? body.url
      : 'private-artisan-inquiry/search-artisan-private-inquiries/',
    { ...body }
  );
export const getArtisanStagingPrivateInquiries = body =>
  api.post(
    body.url
      ? body.url
      : 'private-artisan-inquiry-staging/search-artisan-private-inquiries/',
    { ...body }
  );

export const deleteArtisanPrivateInquiry = payload => {
  const { id, url } = payload;
  if (url) return api.put(`/${url}/${id}`);

  return api.delete(`/$'private-artisan-inquiry'}/${id}`);
};

export const editArtisanPrivateInquiry = (id, body) =>
  api.post(`/private-artisan-inquiry-staging/update/${id}`, { ...body });
// export const editArtisanPrivateInquiry = (id,body) => api.put(`/private-artisan-inquiry/${id}`,{ ...body})

export const getSinglePendingArtisanPrivateInquiry = id =>
  api.get(`private-artisan-inquiry-staging/${id}`);

export const addArtisanPrivateinquiry = body =>
  api.post(`/private-artisan-inquiry-staging/create`, { ...body });
// export const addArtisanPrivateinquiry = ( body) => api.post(`/private-artisan-inquiry/`, {...body})
